import $ from 'jquery';

/* Created by Manuel Nogueira on 25/05/2017
   DON'T JUDGE ME, probably times were different :D */

function checkIfValidNameField(value, regex = "") {
    var exp_regExp = regex ? regex : /^$|^[a-zA-Z\u00C0-\u017F- ']+$/;

    if (!exp_regExp.test(value))
        return false;
    else
        return true;
}

function checkIfValidPhoneNumberField(value, regex = "") {
    var exp_regExp = regex ? regex : /^$|^[+]\d+$|^\d+$/;

    if (!exp_regExp.test(value))
        return false;
    else
        return true;
}

function checkIfValidNumberField(value, regex = "") {
    var exp_regExp = regex ? regex : /^$|^[0-9 ]+$/;
    if (!exp_regExp.test(value))
        return false;
    else
        return true;
}

function checkIfValidCVVField(value, regex = "") {
    var exp_regExp = regex ? regex : /^$|^\d{3,4}$/;
    if (!exp_regExp.test(value))
        return false;
    else
        return true;
}
function checkIfEmailFieldhasAtSign(value, regex = "") {
    if (value.indexOf("@") < 0)
        return false;
    else
        return true;
}
function checkIfEmailFieldhasValidLength(value, validLength = 254) {
    if (value.length > validLength)
        return false;
    else
        return true;
}

function checkIfValidEmailField(value, regex = "") {
    var exp_regExp = regex ? regex : /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!exp_regExp.test(value) || !checkIfEmailFieldhasValidLength(value))
        return false;
    else
        return true;
}

function checkIfStrongPassword(value, regex = ""){
    var exp_regExp = regex ? regex : /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[)(!@#$%^&*])(?=.{8,})/;

    if (!exp_regExp.test(value))
        return false;
    else
        return true;
}

function compareValueWithOtherField(value, otherValue){
    if (value === otherValue)
        return true;
    else
        return false;
}

function isNullOrEmpty(str) {
    if (typeof str === "undefined" || str === '')
        return true;
    else
        return false;
}

function hasAttribute(el, attr) {
    attr = el.attr(attr);

    if (typeof attr !== typeof undefined && attr !== false)
        return true;
    else
        return false;
}

export function blurValidations(form, options) {
    var fields = form.find("input[type='text'],input[type='password'],input[type='email'],input[type='file'],input[type='checkbox'],input[type='radio'],textarea,select");

    options = options != null ? options : { validateHiddenFields: false, showErrorMessage: false, dumbValidations: false };

    for (var i = 0, n = fields.length; i < n; i++) {
        var el = $(fields[i]);

        if (el.is("input[type='text'],input[type='password'],input[type='email'],textarea")) {
            el.blur(function (e) {
                validateFormField($(e.target), options);
            });
        } else if (el.is("input[type='checkbox'],input[type='radio']")) {
            el.click(function (e) {
                validateFormField($(e.target), options);
            });
        } else if (el.is("select,input[type='file']")) {
            el.change(function (e) {
                validateFormField($(e.target), options);
            });
        }
    }
}

export function validateFormField(field, options) {
    var validField = true
        , parentFieldHolder = field.parents(".fieldHolder")
        , errorMessage = ""
        , otherField = $("#"+parentFieldHolder.data("compare-obj"));

    options = options != null ? options : { validateHiddenFields: false, showErrorMessage: false, dumbValidations: false };
    if (options.validateHiddenFields || field.is(":visible")) {
        if (field.is("input[type='text'],input[type='password'],input[type='email'],input[type='file'],textarea,select")) {
            if ((parentFieldHolder.hasClass("required") || hasAttribute(parentFieldHolder, "required")) && isNullOrEmpty(field.val())) {
                field.addClass("error");
                if (options.showErrorMessage) errorMessage = field.data("empty-error-message") ? field.data("empty-error-message") : "This field is required.";
                validField = false;
            } else if ((parentFieldHolder.hasClass("validName") || hasAttribute(parentFieldHolder, "validName")) && !checkIfValidNameField(field.val())) {
                field.addClass("error");
                if (options.showErrorMessage) errorMessage = field.data("name-error-message") ? field.data("name-error-message") : "Invalid Name.";
                validField = false;
            } else if ((parentFieldHolder.hasClass("validEmail") || hasAttribute(parentFieldHolder, "validEmail")) && !checkIfValidEmailField(field.val())) {
                field.addClass("error");
                validField = false;

                if (options.showErrorMessage) {
                    errorMessage = field.data("email-error-message") ? field.data("email-error-message") : "Invalid Email.";

                    if (options.dumbValidations && !checkIfEmailFieldhasAtSign(field.val()))
                        errorMessage = "Email must contain @.";
                    else if (options.dumbValidations && !checkIfEmailFieldhasValidLength(field.val()))
                        errorMessage = "Email can only have 254 Characters.";
                }
            } else if ((parentFieldHolder.hasClass("validPhone") || hasAttribute(parentFieldHolder, "validPhone")) && !checkIfValidPhoneNumberField(field.val())) {
                field.addClass("error");
                if (options.showErrorMessage) errorMessage = field.data("phone-error-message") ? field.data("phone-error-message") : "Invalid Phone.";
                validField = false;
            } else if ((parentFieldHolder.hasClass("validNumber") || hasAttribute(parentFieldHolder, "validNumber")) && !checkIfValidNumberField(field.val())) {
                field.addClass("error");
                if (options.showErrorMessage) errorMessage = field.data("number-error-message") ? field.data("number-error-message") : "Invalid Number.";
                validField = false;
            } else if ((parentFieldHolder.hasClass("validCVV") || hasAttribute(parentFieldHolder, "validCVV")) && !checkIfValidCVVField(field.val())) {
                field.addClass("error");
                if (options.showErrorMessage) errorMessage = field.data("cvv-error-message") ? field.data("cvv-error-message") : "Invalid CVV code.";
                validField = false;
            } else if((parentFieldHolder.hasClass("strongPassword") || hasAttribute(parentFieldHolder, "strongPassword")) && !checkIfStrongPassword(field.val())){
                field.addClass("error");
                if (options.showErrorMessage) errorMessage = field.data("strong-password-error-message") ? field.data("strong-password-error-message") : "A strong password is required.";
                validField = false;
            } else if((parentFieldHolder.hasClass("compare") || hasAttribute(parentFieldHolder, "data-compare-obj")) && !compareValueWithOtherField(field.val(), otherField.val())){
                field.addClass("error");
                if (options.showErrorMessage) errorMessage = parentFieldHolder.data("compare-error-message") ? parentFieldHolder.data("compare-error-message") : "This value is not equal.";

                otherField.addClass("error").parents(".fieldHolder").addClass("hasError").append("<p class='errorMessage'><span>" + errorMessage + "</span></p>");
                validField = false;
            } else{
                field.removeClass("error");
                otherField.removeClass("error");
            }

        } else if (field.is("input[type='checkbox']")) {
            if ((field.hasClass("oneIsRequired") || hasAttribute(field, "oneIsRequired"))) {
                let thisGroup = $("input[name='" + field.attr("name") + "']")
                    , oneIsChecked = false;

                for(let i=0,n=thisGroup.length;i<n;i++){
                    let thisInput = $(thisGroup[i]);

                    if (thisInput.is(":checked"))
                        oneIsChecked = true;
                }

                if(oneIsChecked)
                    thisGroup.removeClass("error");
                else {
                    thisGroup.addClass("error");
                    if (options.showErrorMessage) errorMessage = field.data("empty-error-message") ? field.data("empty-error-message") : "One of these options is required.";
                    validField = false;
                }

            }

            if ((field.hasClass("required") || hasAttribute(field, "required")) && !field.is(":checked")) {
                field.addClass("error");
                if (options.showErrorMessage) errorMessage = field.data("empty-error-message") ? field.data("empty-error-message") : "This field is required.";
                validField = false;
            } else
                field.removeClass("error");
        } else if (field.is("input[type='radio']")) {
            if ((field.hasClass("oneIsRequired") || hasAttribute(field, "oneIsRequired"))) {
                let thisGroup = $("input[name='" + field.attr("name") + "']")
                    , oneIsChecked = false;

                for(let i=0,n=thisGroup.length;i<n;i++){
                    let thisInput = $(thisGroup[i]);

                    if (thisInput.is(":checked"))
                        oneIsChecked = true;
                }

                if(oneIsChecked)
                    thisGroup.removeClass("error");
                else {
                    thisGroup.addClass("error");
                    if (options.showErrorMessage) errorMessage = field.data("empty-error-message") ? field.data("empty-error-message") : "One of these options is required.";
                    validField = false;
                }

            } else if ((field.hasClass("required") || hasAttribute(field, "required")) && !field.is(":checked")) {
                field.addClass("error");
                if (options.showErrorMessage) errorMessage = field.data("empty-error-message") ? field.data("empty-error-message") : "This field is required.";
                validField = false;
            } else
                field.removeClass("error");
        }
        if (options.showErrorMessage){
            parentFieldHolder.removeClass("hasError").find("p.errorMessage").remove();
            if(!field.hasClass("error"))
                otherField.parents(".fieldHolder").removeClass("hasError").find("p.errorMessage").remove();
        }

        if (options.showErrorMessage && !validField && !parentFieldHolder.hasClass("hasError")) {
            var errorMessageClass = field.hasClass("half") && field.prev().is(".half") && !field.prev().hasClass("error") ? "field50" : "";

            errorMessageClass = field.is(".small") && field.prev().is(".small") && !field.prev().hasClass("error") ? "field25" : errorMessageClass;
            parentFieldHolder.addClass("hasError").append("<p class='errorMessage " + errorMessageClass + "'><span>" + errorMessage + "</span></p>");
        }


        /*if (!validField)
            field.trigger("focus");*/

    }
    return validField;
}

export function validateForm(form, options) {
    var fields = form.find("input[type='text'],input[type='password'],input[type='email'],input[type='file'],input[type='checkbox'],input[type='radio'],textarea,select")
        , validForm = true
        , focusTriggered = false;

    options = options != null ? options : { validateHiddenFields: false, showErrorMessage: false, dumbValidations: false };

    for (var i = 0, n = fields.length; i < n; i++) {
        var el = $(fields[i]);

        if (!validateFormField(el, options)) {
            validForm = false;
            if (!focusTriggered) {
                var focusable = el;
                focusTriggered = true;
                //eslint-disable-next-line
                scrollToElement(focusable, -10, function () { focusable.trigger("focus");});
            }
        }
    }
    return validForm;
}

$(function(){
    var floatingInputs = $(".floating-label > input");

    floatingInputs.blur(function () {
        var el = $(this),
            parent = el.parent();

        if (el.val() !== "")
            parent.addClass("hasValue");
        else
            parent.removeClass("hasValue");

    }).blur();
});

/// Given an element (jQuery el) will animate the body to scroll to it's location
/// An offset can be passed so it has some margin if needed
/// Usage: scrollToElement($('element'), offset)
/////////////////////////////////////////////////////
function scrollToElement(el, offset, callback) {
    offset = offset != null ? offset : 0;
    if (typeof el === "object") {

        $('html,body').animate({ scrollTop: el.offset().top + offset }, 500).promise().done(callback);
    }
}

/////////////////////////////////////////////////////
///Given a img and file upload control, set's the selected image inside the img container for preview
/// Usage: previewFile('myImg', 'myFileUpload')
/////////////////////////////////////////////////////
//eslint-disable-next-line
function previewFile(imgControlId, fuControlId) {
    var preview = document.getElementById(imgControlId) //selects the query named img
        , file = document.getElementById(fuControlId).files[0] //sames as here
        , reader = new FileReader();

    reader.onloadend = function () {
        preview.src = reader.result;
    }

    if (file) {
        reader.readAsDataURL(file); //reads the data as a URL
        $(preview).parent().addClass("hasFile");
    } else {
        preview.src = "";
        $(preview).parent().removeClass("hasFile");
    }
}
